import { useEffect, useState } from "react";

/**
 * Returns true when the viewport is ≤ 600px AND the user hasn't opted into the desktop site.
 * The choice is persisted in localStorage as `pr_view_mode` ("mobile" | "desktop").
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    if (localStorage.getItem("pr_view_mode") === "desktop") return false;
    return window.matchMedia("(max-width: 600px)").matches;
  });

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 600px)");
    const handler = () => {
      if (localStorage.getItem("pr_view_mode") === "desktop") {
        setIsMobile(false);
      } else {
        setIsMobile(mq.matches);
      }
    };
    mq.addEventListener("change", handler);
    window.addEventListener("storage", handler);
    return () => {
      mq.removeEventListener("change", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  return isMobile;
}

export function setViewMode(mode) {
  localStorage.setItem("pr_view_mode", mode);
  window.dispatchEvent(new StorageEvent("storage"));
  window.location.reload();
}
